import React, { useState, useEffect, useRef } from "react";
import { FaFilter, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import MarketsItem from "../../components/MarketsItem/MarketsItem";
import Pagination from "../../components/Pagination/Pagination";
import NothingToShowBox from "../../components/NothingToShowBox/NothingToShowBox";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import "react-input-range/lib/css/index.css";
import "./Markets.scss";
import "./Responsive.scss";

const Markets = (props) => {
  const [filterIcon, setFilterIcon] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPage, setMaxPage] = useState();
  const [preloader, setPreloader] = useState(true);
  const [loaderCount, setLoaderCount] = useState(true);
  const [lastCategoryId, setLastCategoryId] = useState([]);
  const [lastSearchKey, setLastSearchKey] = useState("");
  const [lastPriceMin, setLastPriceMin] = useState(0);
  const [lastPriceMax, setLastPriceMax] = useState(0);
  const [allCities, setAllCities] = useState(null);
  const [city, setCity] = useState(null);
  // const [doForFirst, setDoForFirst] = useState(true);
  const [rangeValue, setRangeValue] = useState({ min: 0, max: 0 });
  const [originId, setOriginId] = useState([]);
  const [destinationId, setDestinationId] = useState([]);
  const [markets, setMarkets] = useState([]);
  const user = useSelector((state) => state.user);
  const originRef = useRef();
  const destinationRef = useRef();
  let categoryId = [];

  let searchKey = "";
  let checkForResetPage = false;
  if (props.location.state !== undefined) {
    if (props.location.state.categoryId !== null) {
      categoryId.push(props.location.state.categoryId);
      if (lastCategoryId[0] != props.location.state.categoryId) {
        checkForResetPage = true;
      }
    }
    if (props.location.state.searchKey !== null) {
      searchKey = props.location.state.searchKey;
      if (
        props.location.state.searchKey !== "" &&
        props.location.state.searchKey !== undefined &&
        lastSearchKey !== props.location.state.searchKey
      ) {
        checkForResetPage = true;
      }
    }
  }

  if (lastPriceMin != rangeValue.min || lastPriceMax != rangeValue.max) {
    checkForResetPage = true;
  }

  // const getMaxPrice = async () => {
  //   axios
  //     .get(
  //       "/Product/GetMaxPrice",
  //       user[0]?.token && {
  //         headers: {
  //           Authorization: `Bearer ${user[0]?.token}`,
  //         },
  //       }
  //     )
  //     .then((result) => {
  //       setPriceMax(result.data.data);
  //       if (doForFirst) {
  //         setDoForFirst(false);
  //       }
  //       maxPrice = result.data.data;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const GetFilterIntialData = async (
  //   catergory,
  //   minPrice,
  //   maxPrice,
  //   currentPageId,
  //   key,
  //   orderBy,
  //   provinceId,
  //   cityId
  // ) => {
  //   let initialData;
  //   if (localStorage.getItem("categoryNum")) {
  //     initialData = JSON.stringify({
  //       ProductCategoryId: null,
  //       Key: key,
  //       category: parseInt(localStorage.getItem("categoryNum")),
  //       MinWeight: 0,
  //       MaxWeight: 0,
  //       MinCutting: 0,
  //       MaxCutting: 0,
  //       MinNumberOfJewels: 0,
  //       MaxNumberOfJewels: 0,
  //       MinUnitPrice: minPrice,
  //       MaxUnitPrice: maxPrice,
  //       CountryIds: null,
  //       OrderBy: orderBy,
  //       PageId: currentPageId,
  //       PageCount: 1,
  //       cityId: cityId,
  //       provinceId: provinceId,
  //     });
  //   } else {
  //     initialData = JSON.stringify({
  //       ProductCategoryId: catergory,
  //       Key: key,
  //       MinWeight: 0,
  //       MaxWeight: 0,
  //       MinCutting: 0,
  //       MaxCutting: 0,
  //       MinNumberOfJewels: 0,
  //       MaxNumberOfJewels: 0,
  //       MinUnitPrice: minPrice,
  //       MaxUnitPrice: maxPrice,
  //       CountryIds: null,
  //       OrderBy: orderBy,
  //       PageId: currentPageId,
  //       PageCount: 1,
  //       cityId: cityId,
  //       provinceId: provinceId,
  //     });
  //   }
  //   // await getMaxPage(initialData);
  //   await getAllProduct(initialData);
  //   await getMaxPrice();
  // };

  useEffect(async () => {
    await getAllProduct();
    await getProvinces();
  }, []);
  useEffect(async () => {
    await getProduct();
  }, [originId, destinationId]);

  const getProvinces = async () => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    await fetch(`${Config.apiPath}/api/cities`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setAllCities(
          result.data.map((i) => {
            return {
              value: i.id,
              label: i.name,
            };
          })
        );
      })
      .catch((error) => console.log("error", error));
  };

  // useEffect(async () => {
  //   if (checkForResetPage) {
  //     setCurrentPage(1);
  //     checkForResetPage = false;
  //   }

  //   Config.pageUp();
  //   setLastCategoryId(categoryId);
  //   setLastSearchKey(searchKey);
  //   setLastPriceMax(rangeValue.max);
  //   setLastPriceMin(rangeValue.min);

  //   // if (categoryId.length > 0) {
  //   //   GetFilterIntialData(categoryId, rangeValue.min, rangeValue.max, currentPage, searchKey, 1, province, city);
  //   // } else {
  //   //   GetFilterIntialData(null, rangeValue.min, rangeValue.max, currentPage, searchKey, 1, province, city);
  //   // }
  // }, [
  //   currentPage,
  //   props.location.state !== undefined && props.location.state.categoryId,
  //   props.location.state !== undefined && props.location.state.searchKey,
  //   // localStorage.getItem("categoryNum"),
  // ]);

  // const getMaxPage = async (initialData) => {
  //   let headers = new Headers();
  //   headers.append("Content-Type", "application/json");
  //   user[0]?.token && headers.append("Authorization", `Bearer ${user[0]?.token}`);
  //   let requestOptions = {
  //     method: "POST",
  //     headers: headers,
  //     body: initialData,
  //     redirect: "follow",
  //   };

  //   fetch(Config.apiPath + "/Product/GetMaxPages", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       setMaxPage(result.data);
  //     })
  //     .catch((error) => console.log("error", error));
  // };

  const getProduct = async () => {
    setPreloader(true);
    if (loaderCount) {
      setLoaderCount(false);
    }
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    user[0]?.token && headers.append("Authorization", `Bearer ${user[0]?.token}`);

    let requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(
      Config.apiPath +
        `/Api/WelfareServiceCenters/Filter?originId=${originId.value ? originId.value : ""}&destinationId=${
          destinationId.value ? destinationId.value : ""
        }`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          setMarkets(result.data.welfareServiceCenters);
          setMaxPage(result.data.pageCount);
        }
      })
      .catch((error) => {
        // console.log(error);
        setPreloader(false);
      });
  };
  const getAllProduct = async () => {
    setPreloader(true);
    if (loaderCount) {
      setLoaderCount(false);
    }
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    user[0]?.token && headers.append("Authorization", `Bearer ${user[0]?.token}`);

    let requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/Api/WelfareServiceCenters/GetAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          setMarkets(result.data.welfareServiceCenters);
          setMaxPage(result.data.pageCount);
        }
      })
      .catch((error) => {
        // console.log(error);
        setPreloader(false);
      });
  };

  const setPageHandler = (e) => {
    setCurrentPage(Number(e.target.innerText));
  };

  const nextPageHandler = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPageHandler = () => {
    setCurrentPage(currentPage - 1);
  };

  const removeFilters = async () => {
    setOriginId([]);
    setDestinationId([]);
    await getAllProduct();
    // props.history.push({
    //   pathname: `/products`,
    //   state: { categoryId: null, searchKey: "" },
    // });
    // let provinceSelect = document.getElementById("provinceSelect").options;
    // provinceSelect[0].selected = true;
    // // }
    // let citySelect = document.getElementById("citySelect").options;
    // citySelect[0].selected = true;
    // // }
    // await getMaxPrice();
    // setProvince(null);
    // setCity(null);
    // setPriceMax(priceMax);
    // setRangeValue({ min: 0, max: priceMax });
    // if (categoryId.length > 0) {
    //   GetFilterIntialData(categoryId, 0, priceMax, currentPage, searchKey, 1, null, null);
    // } else {
    //   GetFilterIntialData(null, 0, priceMax, currentPage, searchKey, 1, null, null);
    // }
  };

  // const openFilterList = (e) => {
  //   if (e.target.parentNode.classList.contains("open")) {
  //     e.target.parentNode.classList.remove("open");
  //     e.target.parentNode.style.height = "40px";
  //   } else {
  //     e.target.parentNode.classList.add("open");
  //     e.target.parentNode.style.height = Number(e.target.nextElementSibling.clientHeight + 101) + "px";
  //   }
  // };

  const openMobileProductFilter = (e) => {
    let body = document.body;
    let backdropFilter = document.querySelector(".backdropFilter");
    let mobileProductFilter = document.querySelector(".filterBox.mobile");
    if (mobileProductFilter.classList.contains("open")) {
      body.style.overflowY = "auto";
      backdropFilter.classList.remove("show");
      mobileProductFilter.classList.remove("open");
      setFilterIcon(true);
    } else {
      body.style.overflowY = "hidden";
      mobileProductFilter.classList.add("open");
      backdropFilter.classList.add("show");
      setFilterIcon(false);
    }
  };

  const closeBackdropFilter = (e) => {
    let body = document.body;
    let backdropFilter = document.querySelector(".backdropFilter");
    let mobileProductFilter = document.querySelector(".filterBox.mobile");
    if (mobileProductFilter.classList.contains("open")) {
      body.style.overflowY = "auto";
      backdropFilter.classList.remove("show");
      mobileProductFilter.classList.remove("open");
      setFilterIcon(true);
    } else {
      body.style.overflowY = "hidden";
      mobileProductFilter.classList.add("open");
      backdropFilter.classList.add("show");
      setFilterIcon(false);
    }
  };

  return (
    <section className="marketsWrapper mobile">
      <Helmet>
        <title>{Config.helmetTitle} | مراکز خدمات رفاهی</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="marketsContents">
        <div className="desktop">
          <div className="filterBox mobile">
            <div className="header">
              <div className="headerBox">
                <p className="title">فیلتر ها</p>
                <div className="btnFilter">
                  <button className="btnDeleteFilters" onClick={removeFilters}>
                    حذف فیلتر ها
                  </button>
                </div>
              </div>
              <div className="filterLists open">
                <p className="title">مبدا و مقصد</p>
                <div className="filters">
                  <div className="formWrap">
                    <div className="lists">
                      <p className="mainTitle">مبدا</p>
                      <div className="loadingWrapper">
                        <Select
                          value={originId}
                          options={allCities}
                          className="filterSelect"
                          placeholder="انتخاب"
                          noOptionsMessage={({ inputValue: string }) => "موردی پیدا نشد"}
                          onChange={setOriginId}
                          menuPlacement="bottom"
                          maxMenuHeight={200}
                        />
                      </div>
                      <p className="mainTitle">مقصد</p>
                      <div className="loadingWrapper">
                        <Select
                          value={destinationId}
                          options={allCities}
                          className="filterSelect"
                          placeholder="انتخاب"
                          noOptionsMessage={({ inputValue: string }) => "موردی پیدا نشد"}
                          onChange={setDestinationId}
                          menuPlacement="top"
                          maxMenuHeight={200}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="marketsBox">
            <div className="productTools">
              <p className="title">لیست مراکز ارائه خدمات</p>
              <p className="pageCounter">
                صفحه {currentPage} از {maxPage}
              </p>
            </div>
            <div className="productItems">
              {markets.length > 0 ? (
                <MarketsItem marketsItemData={markets} loading={preloader && loaderCount && preloader} />
              ) : (
                <NothingToShowBox
                  title="مرکزی برای نمایش وجود ندارد!"
                  note1="- برای جستجو از عبارت یا کلمات متداول تر استفاده نمایید"
                  note2="- برای بیشتر شدن دامنه مراکز مورد نظر از فیلتر کمتر استفاده کنید "
                />
              )}
            </div>
            {maxPage > 1 && (
              <Pagination
                currentPage={currentPage}
                maxPage={maxPage}
                setPage={setPageHandler}
                next={nextPageHandler}
                prev={prevPageHandler}
              />
            )}
          </div>
          <div
            className="mobileProductFilterButton"
            data-tooltip="فیلتر محصولات"
            data-tooltip-location="left"
            onClick={(e) => openMobileProductFilter(e)}
          >
            {filterIcon ? <FaFilter /> : <FaTimes />}
          </div>
        </div>
      </div>
      <div className="backdropFilter" onClick={(e) => closeBackdropFilter(e)}></div>
    </section>
  );
};

export default React.memo(Markets);
